import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';
import { createBlock } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { store as blockEditorStore } from '@wordpress/block-editor';
import { store as noticesStore } from '@wordpress/notices';
import { SwiperInit } from './swiper-init';

const SliderToolbar = ({ clientId ,DEFAULT_BLOCK_ATTRIBUTES , animateTargetBlock , sliderRef}) => {
    const { insertBlock, selectBlock } = useDispatch(blockEditorStore);
    const innerBlocks = useSelect(
        (select) => select(blockEditorStore).getBlock(clientId)?.innerBlocks || []
    );

    const { createNotice } = useDispatch(noticesStore);

    // Create a Slide block and insert it.
    const addSlide = () => {
        animateTargetBlock();
        
        const block = createBlock('vayu-blocks/advance-container', {}, [
            createBlock('vayu-blocks/image', {
                ...DEFAULT_BLOCK_ATTRIBUTES
            })
	    ]);

        insertBlock(block, innerBlocks.length, clientId, false);

        // 👇 After a delay, select the newly added block and go to that slide
        setTimeout(() => {
            // selectBlock(newSlideBlock.clientId);

            // Go to that slide (ensure Swiper instance exists)
           const swiperInstance = sliderRef.current?.swiper;
            if (swiperInstance) {
                swiperInstance.update(); // 🔁 Recalculate slides
                swiperInstance.slideTo(innerBlocks.length); // 👉 Go to the new one
            }
        }, 200);

        createNotice('success', 'slide added!', {
			isDismissible: true,
			type: 'snackbar',
		});
    };

    const StartSlider = () => {
        const container = sliderRef.current;
        if (!container) return;

        let swiperInstance = container.swiper;

        if (!swiperInstance || !swiperInstance.slides || swiperInstance.slides.length === 0) return;

        // ✅ Get the first slide DOM element
        const firstSlide = swiperInstance.slides[0];

        if (firstSlide) {
            // 🧠 Option 1: Scroll it into view
            firstSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

            // ✅ Option 2 (More forceful): Apply a transform directly
            swiperInstance.wrapperEl.style.transition = 'transform 0.3s ease-in-out';
            swiperInstance.wrapperEl.style.transform = `translate3d(-${firstSlide.offsetLeft}px, 0, 0)`;

            swiperInstance.activeIndex = 0;
            swiperInstance.update();
        }
    };

    return (
        <>
            <ToolbarGroup>
                <ToolbarButton icon="plus" className='vb-toolbar-align' onClick={addSlide}>
                    {__('Add Slide', 'vayu-blocks')}
                </ToolbarButton>
            </ToolbarGroup>

            <ToolbarGroup>
                <ToolbarButton icon="update" className='vb-toolbar-align' onClick={StartSlider}>
                    {__('Restore', 'vayu-blocks')}
                </ToolbarButton>
            </ToolbarGroup>
        </>
    );
};

export default SliderToolbar;
